export default {
  TOKEN: 'token',
  CURRENT_USER: 'currentUser',
  CURRENT_OUTLET_ID: 'currentOutletId',
  STORE_ID: 'storeID',
  STORE_EXTERNAL_ID: 'storeExternalID',
  CURRENT_PLATFORM: 'currentPlatform',
  STORE_CONFIG: 'storeConfig',
  CURRENT_CURRENCY: 'currentCurrency',
  LIST_OUTLET: 'listOutlet',
  REFREESHED: 'refreshed'
}
